export { AttributionControl } from 'maplibre-gl'

console.warn(`Using AtrributionConrol will pull in the entire maplibre library.`)
